import { MonoTypeOperatorFunction } from 'rxjs';

export function noop<T>(): MonoTypeOperatorFunction<T> {
	return source$ => source$;
}
